import { render, staticRenderFns } from "./m-thumbnail-v2.vue?vue&type=template&id=1bf8f37f"
import script from "./m-thumbnail-v2.vue?vue&type=script&lang=js"
export * from "./m-thumbnail-v2.vue?vue&type=script&lang=js"
import style0 from "./m-thumbnail-v2.vue?vue&type=style&index=0&id=1bf8f37f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports